/**
 * Position Pick Source
 *
 * Which viewer leg a "Set Point" click came from. The position-assignment
 * callback carries this alongside the world coordinates, so a consumer can tell
 * a 3D pick from a 360 pick.
 *
 * `dbId` cannot stand in for it: a point-cloud pick is a 3D pick with a null
 * dbId, exactly like a 360 pick. Only this field separates the two legs.
 *
 * Producers:
 * - `src/scripts/js/forgeviewer.js` — 3D leg, both the model hit and the
 *   point-cloud fallback
 * - `src/scripts/js/forgeService.js` — 360 leg
 *
 * ⚠️ The wire values are compared as bare string literals by existing consumers
 * (the master-tag cards read `worldPoint?.source === '3d'`). Add members freely,
 * but do not rename these two values without updating those comparisons.
 */

export const POSITION_PICK_SOURCE = Object.freeze({
  MODEL_3D: '3d',
  PANO_360: '360',
});
